export const cars =[
    {
        image: "/images/Toyota_Corolla/1.jpg",
        // title: "Toyota Corolla"
    },
    {
        image: "/images/Toyota_Corolla/2.jpg",
        // title: "Toyota Corolla"
    },
    {
        image: "/images/Toyota_Corolla/3.jpg",
        // title: "Toyota Corolla"
    },
    {
        image: "/images/Toyota_Corolla/4.jpg",
        // title: "Toyota Corolla"
    },
    {
        image: "/images/Toyota_Corolla/5.jpg",
        // title: "Toyota Corolla"
    }
];